var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _vm.info
        ? _c(
            "el-row",
            {
              staticStyle: { height: "30px", "border-bottom": "1px solid #ddd" }
            },
            [_c("el-col", { attrs: { span: 22 } }, [_vm._v(" 代采订单详情 ")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm.info
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-alert", {
                    attrs: {
                      title:
                        "当前代采订单状态：" +
                        (_vm.info.status_label || "--") +
                        ";  交易方式：" +
                        (_vm.info.wcg_order_cg_type || "--") +
                        ";   支付方式：" +
                        (_vm.info.wcg_order_pay_tool || "--"),
                      type:
                        _vm.info &&
                        _vm.info.status >= 2 &&
                        _vm.info.status < 9 &&
                        _vm.info.status != 5
                          ? "success"
                          : "error",
                      closable: false
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { border: "1px solid #ddd" } },
        [
          _vm.info
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        background: "#f3f3f3",
                        height: "30px",
                        "line-height": "30px",
                        padding: "0 25px"
                      },
                      attrs: { span: 24 }
                    },
                    [_vm._v("\n        基本信息\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.info.status < 2 || _vm.info.status == 9,
                          expression: "info.status < 2 || info.status == 9"
                        }
                      ],
                      key: "table5",
                      staticStyle: { width: "100%" },
                      attrs: { data: [_vm.info], border: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "woid",
                          label: "代采订单编号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sumNum",
                          label: "代采数量",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "market_nikename",
                          label: "市场/子市场",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "supply_name",
                          label: "档口号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pgname",
                          label: "代采组",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "create_time",
                          label: "提交时间",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pay_time",
                          label: "支付时间",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.info.status >= 2 && _vm.info.status != 9,
                          expression: "info.status >= 2 && info.status != 9"
                        }
                      ],
                      key: "table6",
                      staticStyle: { width: "100%" },
                      attrs: { data: [_vm.info], border: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "woid",
                          label: "代采订单编号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sumNum",
                          label: "代采数量",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "dk_num",
                          label: "前置数量",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "wdd_num",
                          label: "抵扣数量",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "market_nikename",
                          label: "市场/子市场",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "supply_name",
                          label: "商家",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pgname",
                          label: "代采组",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "create_time",
                          label: "提交时间",
                          align: "center",
                          width: "200"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pay_time",
                          label: "支付时间",
                          align: "center",
                          width: "210"
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.info.status >= 2 && _vm.info.status < 9
                              ? {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-date-picker", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.index == scope.$index,
                                            expression: "index == scope.$index"
                                          }
                                        ],
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "datetime",
                                          placeholder: scope.row.pay_time,
                                          align: "center",
                                          size: "mini"
                                        },
                                        model: {
                                          value: _vm.paytime,
                                          callback: function($$v) {
                                            _vm.paytime = $$v
                                          },
                                          expression: "paytime"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.index !== scope.$index,
                                              expression:
                                                "index !== scope.$index"
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(scope.row.pay_time) +
                                              "\n            "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#409eff",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.updatePaytime(
                                                scope.$index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.index == scope.$index
                                                ? "完成"
                                                : "修改"
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              : null
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.source == 1
        ? _c(
            "div",
            [
              _vm.info && (_vm.info.status < 2 || _vm.info.status == 9)
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { position: "relative", height: "100%" },
                          attrs: { span: 10 }
                        },
                        [
                          _c("div", { staticClass: "card-title" }, [
                            _vm._v(
                              "单据信息 " + _vm._s(_vm.info.docs.length) + "张"
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.isXhhk(_vm.info.cg_type) || _vm.dialogVisible1
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "viewer",
                                    {
                                      staticClass: "viewer",
                                      attrs: { images: _vm.info.docs }
                                    },
                                    _vm._l(_vm.info.docs, function(src) {
                                      return _c("img", {
                                        key: src,
                                        staticStyle: {
                                          "max-width": "100%",
                                          "max-height": "100%"
                                        },
                                        attrs: { src: src }
                                      })
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isXhhk(_vm.info.cg_type) && !_vm.dialogVisible1
                            ? _c(
                                "div",
                                { staticStyle: { "margin-top": "30%" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        "text-align": "center"
                                      }
                                    },
                                    [
                                      _c("p", [_vm._v("注意！")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n              此代采单属于先货后款类型只需审核商品数量与金额，无需银行转账\n            "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-left": "40%"
                                      },
                                      attrs: { type: "primary", size: "small" },
                                      on: { click: _vm.showXhhkReceipt }
                                    },
                                    [_vm._v("查看代采单据")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c(
                            "el-row",
                            [
                              _vm.info.is_new == 1
                                ? _c(
                                    "el-col",
                                    [
                                      _c("div", { staticClass: "card-title" }, [
                                        _vm._v("商品信息")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-table",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            data: _vm.info.new_goods_list.list,
                                            border: "",
                                            height: "750"
                                          }
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "goods_name",
                                              label: "代采计划",
                                              align: "center"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.planid
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row
                                                              .wcg_plan_ptype
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row
                                                              .create_time
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticStyle: {
                                                            color: "red"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                scope.row
                                                                  .goods_type
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              40714738
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "goods_name",
                                              label: "商品名称",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "goods_no",
                                              label: "货号",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "co_val",
                                              label: "颜色",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "si_val",
                                              label: "尺码",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "brand_name",
                                              label: "品牌",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "num",
                                              label: "实际数量",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "addedNum",
                                              label: "前置数量",
                                              align: "center"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      scope.row.dk_num > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color: "red"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .dk_num
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : _c("span", [
                                                            _vm._v("0")
                                                          ])
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              2764279650
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "plan_price",
                                              label: "商家价",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "price",
                                              label: "代采价",
                                              align: "center"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              scope.row.price,
                                                            expression:
                                                              "scope.row.price"
                                                          }
                                                        ],
                                                        staticStyle: {
                                                          width: "100%",
                                                          "text-align":
                                                            "center",
                                                          "font-size": "14px",
                                                          border: "0"
                                                        },
                                                        style: {
                                                          color:
                                                            Number(
                                                              scope.row.price
                                                            ) ==
                                                            Number(
                                                              scope.row
                                                                .plan_price
                                                            )
                                                              ? "#606266"
                                                              : "#FF4040"
                                                        },
                                                        attrs: { type: "text" },
                                                        domProps: {
                                                          value: scope.row.price
                                                        },
                                                        on: {
                                                          blur: function(
                                                            $event
                                                          ) {
                                                            return _vm.update(
                                                              scope.row.price,
                                                              scope.$index
                                                            )
                                                          },
                                                          focus: function(
                                                            $event
                                                          ) {
                                                            _vm.initData =
                                                              scope.row.price
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              scope.row,
                                                              "price",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              2859539658
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "total",
                                              label: "开单价小计",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "activity_fee",
                                              label: "活动服务费小计",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "service_fee",
                                              label:
                                                "佣金小计(" +
                                                (_vm.info.ext &&
                                                  _vm.info.ext
                                                    .service_fee_rate) +
                                                "%)",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop:
                                                "dispense_commission_amount",
                                              label: "小店佣金",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "refund_service_fee",
                                              label:
                                                "退货服务费小计(" +
                                                (_vm.info.ext &&
                                                  _vm.info.ext
                                                    .refund_service_fee_rate) +
                                                "%)",
                                              align: "center"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              prop: "true_total",
                                              label: "实付金额小计",
                                              align: "center"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                            height: "40px",
                                            background: "#f3f3f3",
                                            "line-height": "40px",
                                            padding: "0 40px",
                                            "font-size": "14px",
                                            color: "#ff4040"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              合计代采金额： ¥" +
                                              _vm._s(_vm.info.sumPrice) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c("el-col", [
                                _c("div", { staticClass: "card-title" }, [
                                  _vm._v("代采备注")
                                ]),
                                _vm._v(" "),
                                _vm.info
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          border: "1px solid #ddd",
                                          padding: "15px"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "pay-comment",
                                          attrs: {
                                            type: "textarea",
                                            rows: 2,
                                            placeholder: "暂无备注信息",
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.info.note,
                                            callback: function($$v) {
                                              _vm.$set(_vm.info, "note", $$v)
                                            },
                                            expression: "info.note"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { margin: "20px 0" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-title",
                              on: {
                                click: function($event) {
                                  return _vm.toggleFilter(
                                    "activityServiceTogglle"
                                  )
                                }
                              }
                            },
                            [
                              _c("el-button", {
                                staticStyle: { "margin-left": "auto" },
                                attrs: {
                                  type: "text",
                                  icon: _vm.toggle.activityServiceTogglle
                                    ? "el-icon-arrow-down"
                                    : "el-icon-arrow-up"
                                }
                              }),
                              _vm._v("\n          活动服务费商品\n        ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.toggle.activityServiceTogglle,
                                    expression: "toggle.activityServiceTogglle"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: _vm.activity_fee_detail.list,
                                      "span-method": _vm.rowSpan
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "special_start_time",
                                        label: "专场开始时间",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "goods_name",
                                        label: "商品名称",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "goods_no",
                                        label: "货号",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "co_val",
                                        label: "颜色",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "si_val",
                                        label: "尺码",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "price",
                                        label: "拿货单价",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "num",
                                        label: "开单数量",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "activity_time",
                                        label: "活动时间",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "activity_id",
                                        label: "活动ID",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "activity_type",
                                        label: "活动类型",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "activity_name",
                                        label: "活动名称",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "discount_shop_price",
                                        label: "小计",
                                        align: "center"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      height: "40px",
                                      background: "#f3f3f3",
                                      "line-height": "40px",
                                      padding: "0 40px",
                                      "font-size": "14px",
                                      color: "#ff4040"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              活动服务费： ¥" +
                                        _vm._s(_vm.info.activity_price) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-title",
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "row",
                                "align-items": "center",
                                "justify-content": "space-between"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleFilter("activityCostTogglle")
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("el-button", {
                                    staticStyle: { "margin-left": "auto" },
                                    attrs: {
                                      type: "text",
                                      icon: _vm.toggle.activityCostTogglle
                                        ? "el-icon-arrow-down"
                                        : "el-icon-arrow-up"
                                    }
                                  }),
                                  _vm._v("活动费抵扣商品\n          ")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "success" },
                                  on: { click: _vm.exportActivityGoods }
                                },
                                [_vm._v("\n            导出\n          ")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.toggle.activityCostTogglle,
                                    expression: "toggle.activityCostTogglle"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: _vm.activityGoodsInfo,
                                      border: ""
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "活动时间",
                                        prop: "activity_time",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "商品名称",
                                        prop: "goods_name",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "货号",
                                        prop: "goods_no",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "颜色/尺码",
                                        prop: "co_si",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "SKU编号",
                                        prop: "sku",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "单件优惠额",
                                        prop: "activity_fee",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "抵扣数量",
                                        prop: "num",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "订单ID",
                                        prop: "order_id",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "活动ID",
                                        prop: "activity_id",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "活动类型",
                                        prop: "activity_type_text",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "活动名称",
                                        prop: "activity_name",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "活动费抵扣小计",
                                        prop: "activity_fee_amount",
                                        align: "center"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      height: "40px",
                                      background: "#f3f3f3",
                                      "line-height": "40px",
                                      padding: "0 40px",
                                      "font-size": "14px",
                                      color: "#ff4040"
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        "合计活动费抵扣金额：¥" +
                                          _vm._s(_vm.activity_fee_amount)
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-title",
                              on: {
                                click: function($event) {
                                  return _vm.toggleFilter(
                                    "concedeBenefitsToggle"
                                  )
                                }
                              }
                            },
                            [
                              _c("el-button", {
                                staticStyle: { "margin-left": "auto" },
                                attrs: {
                                  type: "text",
                                  icon: _vm.toggle.concedeBenefitsToggle
                                    ? "el-icon-arrow-down"
                                    : "el-icon-arrow-up"
                                }
                              }),
                              _vm._v(
                                "\n          让利佣金账单抵扣明细\n        "
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.toggle.concedeBenefitsToggle,
                                    expression: "toggle.concedeBenefitsToggle"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.rebateData.list,
                                      border: "",
                                      height: "200"
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "reporting_period",
                                        label: "让利账期",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "bill_no",
                                        label: "让利账单编号",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "confirm_time",
                                        label: "让利账单确认时间",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "amount_price",
                                        label: "总结算金额",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "deduction_price",
                                        label: "本单让利佣金抵扣金额",
                                        align: "center"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      height: "40px",
                                      background: "#f3f3f3",
                                      "line-height": "40px",
                                      padding: "0 40px",
                                      "font-size": "14px",
                                      color: "#ff4040"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              合计让利佣金抵扣金额： ¥" +
                                        _vm._s(_vm.rebateData.total) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-title",
                              on: {
                                click: function($event) {
                                  return _vm.toggleFilter("goodsToggle")
                                }
                              }
                            },
                            [
                              _c("el-button", {
                                staticStyle: { "margin-left": "auto" },
                                attrs: {
                                  type: "text",
                                  icon: _vm.toggle.goodsToggle
                                    ? "el-icon-arrow-down"
                                    : "el-icon-arrow-up"
                                }
                              }),
                              _vm._v("\n          商品抵扣列表\n        ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.toggle.goodsToggle,
                                    expression: "toggle.goodsToggle"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.info.ded.goodsList,
                                      border: "",
                                      height: "200"
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "goods_name",
                                        label: "商品名称",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "goods_no",
                                        label: "货号",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "co_val",
                                        label: "颜色",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "si_val",
                                        label: "尺码",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "address",
                                        label: "品牌",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "address",
                                        label: "买手组",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "num",
                                        label: "数量",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "price",
                                        label: "代采价",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "status_label",
                                        label: "抵扣状态",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "sum_price",
                                        label: "抵扣金额",
                                        align: "center"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      height: "40px",
                                      background: "#f3f3f3",
                                      "line-height": "40px",
                                      padding: "0 40px",
                                      "font-size": "14px",
                                      color: "#ff4040"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              合计商品抵扣金额： ¥" +
                                        _vm._s(_vm.info.ded.sumPrice) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      ["2", "5"].includes(_vm.source)
        ? _c(
            "div",
            [
              _vm.info && (_vm.info.status < 2 || _vm.info.status == 9)
                ? _c(
                    "el-row",
                    [
                      _vm.info.is_new == 1
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c("div", { staticClass: "card-title" }, [
                                _vm._v("商品信息")
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.info.new_goods_list.list,
                                    border: "",
                                    height: "750"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "goods_name",
                                      label: "代采计划",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("p", [
                                                _vm._v(_vm._s(scope.row.planid))
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.wcg_plan_ptype
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(scope.row.create_time)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: { color: "red" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        scope.row.goods_type
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      360109810
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "goods_name",
                                      label: "商品名称",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "goods_no",
                                      label: "货号",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "co_val",
                                      label: "颜色",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "si_val",
                                      label: "尺码",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "brand_name",
                                      label: "品牌",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "num",
                                      label: "实际数量",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "addedNum",
                                      label: "前置数量",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              scope.row.dk_num > 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "red"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(scope.row.dk_num)
                                                      )
                                                    ]
                                                  )
                                                : _c("span", [_vm._v("0")])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2764279650
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "plan_price",
                                      label: "商家价",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "price",
                                      label: "代采价",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: scope.row.price,
                                                    expression:
                                                      "scope.row.price"
                                                  }
                                                ],
                                                staticStyle: {
                                                  width: "100%",
                                                  "text-align": "center",
                                                  "font-size": "14px",
                                                  border: "0"
                                                },
                                                style: {
                                                  color:
                                                    Number(scope.row.price) ==
                                                    Number(scope.row.plan_price)
                                                      ? "#606266"
                                                      : "#FF4040"
                                                },
                                                attrs: { type: "text" },
                                                domProps: {
                                                  value: scope.row.price
                                                },
                                                on: {
                                                  blur: function($event) {
                                                    return _vm.update(
                                                      scope.row.price,
                                                      scope.$index
                                                    )
                                                  },
                                                  focus: function($event) {
                                                    _vm.initData =
                                                      scope.row.price
                                                  },
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      scope.row,
                                                      "price",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3423565088
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "total",
                                      label: "开单价小计",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "activity_fee",
                                      label: "活动服务费小计",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "service_fee",
                                      label:
                                        "佣金小计(" +
                                        (_vm.info.ext &&
                                          _vm.info.ext.service_fee_rate) +
                                        "%)",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "dispense_commission_amount",
                                      label: "小店佣金",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "refund_service_fee",
                                      label:
                                        "退货服务费小计(" +
                                        (_vm.info.ext &&
                                          _vm.info.ext
                                            .refund_service_fee_rate) +
                                        "%)",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "true_total",
                                      label: "实付金额小计",
                                      align: "center"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "right",
                                    height: "40px",
                                    background: "#f3f3f3",
                                    "line-height": "40px",
                                    padding: "0 40px",
                                    "font-size": "14px",
                                    color: "#ff4040"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          合计代采金额： ¥" +
                                      _vm._s(_vm.info.sumPrice) +
                                      "\n        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.info && (_vm.info.status < 2 || _vm.info.status == 9)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { margin: "20px 0" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-title",
                              on: {
                                click: function($event) {
                                  return _vm.toggleFilter(
                                    "activityServiceTogglle"
                                  )
                                }
                              }
                            },
                            [
                              _c("el-button", {
                                staticStyle: { "margin-left": "auto" },
                                attrs: {
                                  type: "text",
                                  icon: _vm.toggle.activityServiceTogglle
                                    ? "el-icon-arrow-down"
                                    : "el-icon-arrow-up"
                                }
                              }),
                              _vm._v("\n          活动服务费商品\n        ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.toggle.activityServiceTogglle,
                                    expression: "toggle.activityServiceTogglle"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: _vm.activity_fee_detail.list,
                                      "span-method": _vm.rowSpan
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "special_start_time",
                                        label: "专场开始时间",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "goods_name",
                                        label: "商品名称",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "goods_no",
                                        label: "货号",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "co_val",
                                        label: "颜色",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "si_val",
                                        label: "尺码",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "price",
                                        label: "拿货单价",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "num",
                                        label: "开单数量",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "activity_time",
                                        label: "活动时间",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "activity_id",
                                        label: "活动ID",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "activity_type",
                                        label: "活动类型",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "activity_name",
                                        label: "活动名称",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "discount_shop_price",
                                        label: "小计",
                                        align: "center"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      height: "40px",
                                      background: "#f3f3f3",
                                      "line-height": "40px",
                                      padding: "0 40px",
                                      "font-size": "14px",
                                      color: "#ff4040"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              活动服务费： ¥" +
                                        _vm._s(_vm.info.activity_price) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-title",
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "row",
                                "align-items": "center",
                                "justify-content": "space-between"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleFilter("activityCostTogglle")
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("el-button", {
                                    staticStyle: { "margin-left": "auto" },
                                    attrs: {
                                      type: "text",
                                      icon: _vm.toggle.activityCostTogglle
                                        ? "el-icon-arrow-down"
                                        : "el-icon-arrow-up"
                                    }
                                  }),
                                  _vm._v("活动费抵扣商品\n          ")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "success" },
                                  on: { click: _vm.exportActivityGoods }
                                },
                                [_vm._v("\n            导出\n          ")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.toggle.activityCostTogglle,
                                    expression: "toggle.activityCostTogglle"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: _vm.activityGoodsInfo,
                                      border: ""
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "活动时间",
                                        prop: "activity_time",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "商品名称",
                                        prop: "goods_name",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "货号",
                                        prop: "goods_no",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "颜色/尺码",
                                        prop: "co_si",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "SKU编号",
                                        prop: "sku",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "单件优惠额",
                                        prop: "activity_fee",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "抵扣数量",
                                        prop: "num",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "订单ID",
                                        prop: "order_id",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "活动ID",
                                        prop: "activity_id",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "活动类型",
                                        prop: "activity_type_text",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "活动名称",
                                        prop: "activity_name",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "活动费抵扣小计",
                                        prop: "activity_fee_amount",
                                        align: "center"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      height: "40px",
                                      background: "#f3f3f3",
                                      "line-height": "40px",
                                      padding: "0 40px",
                                      "font-size": "14px",
                                      color: "#ff4040"
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        "合计活动费抵扣金额：¥" +
                                          _vm._s(_vm.activity_fee_amount)
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-title",
                              on: {
                                click: function($event) {
                                  return _vm.toggleFilter(
                                    "concedeBenefitsToggle"
                                  )
                                }
                              }
                            },
                            [
                              _c("el-button", {
                                staticStyle: { "margin-left": "auto" },
                                attrs: {
                                  type: "text",
                                  icon: _vm.toggle.concedeBenefitsToggle
                                    ? "el-icon-arrow-down"
                                    : "el-icon-arrow-up"
                                }
                              }),
                              _vm._v(
                                "\n          让利佣金账单抵扣明细\n        "
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.toggle.concedeBenefitsToggle,
                                    expression: "toggle.concedeBenefitsToggle"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.rebateData.list,
                                      border: "",
                                      height: "200"
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "reporting_period",
                                        label: "让利账期",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "bill_no",
                                        label: "让利账单编号",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "confirm_time",
                                        label: "让利账单确认时间",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "amount_price",
                                        label: "总结算金额",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "deduction_price",
                                        label: "本单让利佣金抵扣金额",
                                        align: "center"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      height: "40px",
                                      background: "#f3f3f3",
                                      "line-height": "40px",
                                      padding: "0 40px",
                                      "font-size": "14px",
                                      color: "#ff4040"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              合计让利佣金抵扣金额： ¥" +
                                        _vm._s(_vm.rebateData.total) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-title",
                              on: {
                                click: function($event) {
                                  return _vm.toggleFilter("goodsToggle")
                                }
                              }
                            },
                            [
                              _c("el-button", {
                                staticStyle: { "margin-left": "auto" },
                                attrs: {
                                  type: "text",
                                  icon: _vm.toggle.goodsToggle
                                    ? "el-icon-arrow-down"
                                    : "el-icon-arrow-up"
                                }
                              }),
                              _vm._v("\n          商品抵扣列表\n        ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-collapse-transition", [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.toggle.goodsToggle,
                                    expression: "toggle.goodsToggle"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "el-table",
                                  {
                                    key: "table2",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.info.ded.goodsList,
                                      border: "",
                                      height: "400"
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "img",
                                        label: "商品图片",
                                        align: "center"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "viewer",
                                                        rawName: "v-viewer"
                                                      }
                                                    ],
                                                    staticStyle: {
                                                      width: "40px",
                                                      height: "40px",
                                                      overflow: "hidden",
                                                      cursor: "pointer"
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        width: "100%",
                                                        height: "100%"
                                                      },
                                                      attrs: {
                                                        src: scope.row.img
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2311115079
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "goods_name",
                                        label: "商品名称",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "goods_no",
                                        label: "货号",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "co_val",
                                        label: "颜色",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "si_val",
                                        label: "尺码",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "brand_name",
                                        label: "品牌",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "pg_name",
                                        label: "买手组",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "num",
                                        label: "数量",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "price",
                                        label: "代采价",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "status_label",
                                        label: "抵扣状态",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "remainderPrice",
                                        label: "剩余金额",
                                        align: "center"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "sum_price",
                                        label: "抵扣金额",
                                        align: "center"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      height: "40px",
                                      background: "#f3f3f3",
                                      "line-height": "40px",
                                      padding: "0 40px",
                                      "font-size": "14px",
                                      color: "#ff4040"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              合计商品抵扣金额： ¥" +
                                        _vm._s(_vm.info.ded.sumPrice) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-col", [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v("代采备注")
                    ]),
                    _vm._v(" "),
                    _vm.info
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              border: "1px solid #ddd",
                              padding: "15px",
                              height: "218px"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "pay-comment",
                              attrs: {
                                type: "textarea",
                                rows: 9,
                                placeholder: "暂无备注信息",
                                disabled: ""
                              },
                              model: {
                                value: _vm.info.note,
                                callback: function($$v) {
                                  _vm.$set(_vm.info, "note", $$v)
                                },
                                expression: "info.note"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.info
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("金额信息")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: [_vm.info], border: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "create_price",
                          label: "代采金额",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "活动服务费", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.activity_price) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1795216354
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label:
                              "佣金合计(" +
                              (_vm.info.ext && _vm.info.ext.service_fee_rate) +
                              "%)",
                            align: "center"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.info.ext && _vm.info.ext.service_fee
                                ) +
                                "\n          "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        { attrs: { label: "小店佣金", align: "center" } },
                        [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.info.ext &&
                                    _vm.info.ext.dispense_commission_amount
                                ) +
                                "\n          "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            label:
                              "退货服务费合计(" +
                              (_vm.info.ext &&
                                _vm.info.ext.refund_service_fee_rate) +
                              "%)",
                            align: "center"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.info.ext &&
                                    _vm.info.ext.refund_service_fee
                                ) +
                                "\n          "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "ded_price",
                          label: "实付金额合计",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(_vm._s(scope.row.true_price))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2907839471
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "ded_activity_fee",
                          label: "活动费抵扣金额",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.info.ext &&
                                            _vm.info.ext.ded_activity_fee
                                        )
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1329592877
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "让利佣金抵扣金额", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(_vm._s(_vm.rebateData.total || ""))]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          122243060
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "ded_price",
                          label: "商品抵扣合计",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(_vm._s(scope.row.ded_price))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3351087164
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pay_price",
                          label: "实际结算金额",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("div", { staticStyle: { color: "red" } }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.pay_price) +
                                        "\n            "
                                    )
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2412636326
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.info &&
      ((_vm.info.status >= 2 && _vm.info.status < 9) || _vm.info.status == 11)
        ? _c(
            "el-row",
            [
              _c("el-col", [
                _c("div", { staticClass: "card-title" }, [_vm._v("单据信息")]),
                _vm._v(" "),
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "100%",
                      "border-collapse": "collapse",
                      color: "#606266"
                    }
                  },
                  [
                    _c("tr", { staticStyle: { height: "80px" } }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "50%",
                            border: "1px solid #ddd",
                            "border-collapse": "collapse",
                            "text-align": "center"
                          }
                        },
                        [
                          _vm._v(
                            "\n            代采单据（" +
                              _vm._s(_vm.info.docs.length) +
                              "张）\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "50%",
                            border: "1px solid #ddd",
                            "border-collapse": "collapse",
                            padding: "0 40px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                { name: "viewer", rawName: "v-viewer" }
                              ],
                              staticStyle: {
                                width: "40px",
                                height: "40px",
                                overflow: "hidden",
                                cursor: "pointer",
                                display: "inline-block"
                              }
                            },
                            _vm._l(_vm.info.docs, function(img, idx) {
                              return _c("img", {
                                key: idx,
                                staticStyle: { width: "100%", height: "100%" },
                                attrs: { src: img }
                              })
                            }),
                            0
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.info.status != 10
                      ? _c("tr", { staticStyle: { height: "80px" } }, [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "50%",
                                border: "1px solid #ddd",
                                "border-collapse": "collapse",
                                "text-align": "center"
                              }
                            },
                            [
                              _vm._v(
                                "\n            付款回执（" +
                                  _vm._s(_vm.info.pay_docs.length) +
                                  "张）\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: {
                                width: "50%",
                                border: "1px solid #ddd",
                                "border-collapse": "collapse",
                                padding: "10px 40px"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    { name: "viewer", rawName: "v-viewer" }
                                  ],
                                  staticStyle: {
                                    width: "40px",
                                    height: "40px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "vertical-align": "middle",
                                    "margin-right": "20px"
                                  }
                                },
                                _vm._l(_vm.info.pay_docs, function(img, idx) {
                                  return _c("img", {
                                    key: idx,
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%"
                                    },
                                    attrs: { src: img }
                                  })
                                }),
                                0
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c("div", { staticClass: "card-title" }, [_vm._v("付款信息")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  key: "table4",
                  staticStyle: { width: "100%" },
                  attrs: { data: [_vm.info], border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay_account",
                      label: "收款人银行账号",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.info
                          ? {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.info.bank_is_verify == 1
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticStyle: {
                                            size: "mini",
                                            color: "#0e0e0e"
                                          },
                                          attrs: { type: "warning" }
                                        },
                                        [_vm._v("已验证")]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.pay_account) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          : null
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay_contact",
                      label: "收款人姓名",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay_bank",
                      label: "收款人银行",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cnap_name",
                      label: "收款银行支行",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" }
                  }),
                  _vm._v(" "),
                  _vm.info &&
                  _vm.info.status == 1 &&
                  _vm.info.cg_type !== _vm.CG_TYPT_REGULAR_PICK
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "address",
                          label: "付款回执（" + _vm.files.length + "张）",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            "margin-right": "10px"
                                          },
                                          attrs: {
                                            action: _vm.action,
                                            multiple: "",
                                            accept: "image/*",
                                            "on-success": _vm.uploadSuccess,
                                            "on-remove": _vm.handleRemove,
                                            limit: 9,
                                            "on-exceed": _vm.handleExceed,
                                            "file-list": _vm.files,
                                            "with-credentials": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "primary"
                                              }
                                            },
                                            [_vm._v("上传回执")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.files.length > 0,
                                                  expression: "files.length > 0"
                                                }
                                              ],
                                              attrs: {
                                                size: "small",
                                                type: "success"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.confirmUpload.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("完成")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.info && _vm.info.status == 1
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "danger"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.reject()
                                                }
                                              }
                                            },
                                            [_vm._v("驳回")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1281645397
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.info && _vm.info.status >= 2 && _vm.info.status != 9
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("商品信息")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      key: "table1",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.info.new_goods_list.list,
                        border: "",
                        height: "400"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "goods_name",
                          label: "代采计划",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("p", [_vm._v(_vm._s(scope.row.planid))]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(_vm._s(scope.row.wcg_plan_ptype))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(_vm._s(scope.row.create_time))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticStyle: { color: "red" } }, [
                                    _vm._v(_vm._s(scope.row.goods_type))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2703230226
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "img",
                          label: "商品图片",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        { name: "viewer", rawName: "v-viewer" }
                                      ],
                                      staticStyle: {
                                        width: "40px",
                                        height: "40px",
                                        overflow: "hidden",
                                        cursor: "pointer",
                                        margin: "auto"
                                      }
                                    },
                                    _vm._l(scope.row.middle_img, function(
                                      item,
                                      idx
                                    ) {
                                      return _c("img", {
                                        key: idx,
                                        staticStyle: {
                                          "max-width": "100%",
                                          "max-height": "100%"
                                        },
                                        attrs: { src: item }
                                      })
                                    }),
                                    0
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3931318741
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goods_name",
                          label: "商品名称",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goods_no",
                          label: "货号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "co_val",
                          label: "颜色",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "si_val",
                          label: "尺码",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "brand_name",
                          label: "品牌",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pg_name",
                          label: "买手组",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "num", label: "数量", align: "center" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "addedNum",
                          label: "前置数量",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.addedNum > 0
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v(_vm._s(scope.row.addedNum))]
                                      )
                                    : _c("span", [_vm._v("0")])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1550315298
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "price",
                          label: "代采价",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: scope.row.price,
                                        expression: "scope.row.price"
                                      }
                                    ],
                                    staticStyle: {
                                      width: "100%",
                                      "text-align": "center",
                                      "font-size": "14px",
                                      border: "0"
                                    },
                                    attrs: { type: "text" },
                                    domProps: { value: scope.row.price },
                                    on: {
                                      blur: function($event) {
                                        return _vm.update(
                                          scope.row.price,
                                          scope.$index
                                        )
                                      },
                                      focus: function($event) {
                                        _vm.initData = scope.row.price
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          scope.row,
                                          "price",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1238666636
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "total",
                          label: "开单价小计",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "activity_fee",
                          label: "活动服务费小计",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "service_fee",
                          label:
                            "佣金小计(" +
                            (_vm.info.ext && _vm.info.ext.service_fee_rate) +
                            "%)",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "dispense_commission_amount",
                          label: "小店佣金",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "refund_service_fee",
                          label:
                            "退货服务费小计(" +
                            (_vm.info.ext &&
                              _vm.info.ext.refund_service_fee_rate) +
                            "%)",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "true_total",
                          label: "实付金额小计",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        height: "40px",
                        background: "#f3f3f3",
                        "line-height": "40px",
                        padding: "0 40px",
                        "font-size": "14px",
                        color: "#ff4040"
                      }
                    },
                    [
                      _vm._v(
                        "\n        合计代采金额： ¥" +
                          _vm._s(_vm.info.sumPrice) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.info && _vm.info.status >= 2 && _vm.info.status != 9
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { margin: "20px 0" }, attrs: { span: 24 } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-title",
                      on: {
                        click: function($event) {
                          return _vm.toggleFilter("activityServiceTogglle")
                        }
                      }
                    },
                    [
                      _c("el-button", {
                        staticStyle: { "margin-left": "auto" },
                        attrs: {
                          type: "text",
                          icon: _vm.toggle.activityServiceTogglle
                            ? "el-icon-arrow-down"
                            : "el-icon-arrow-up"
                        }
                      }),
                      _vm._v("\n        活动服务费商品\n      ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-collapse-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.toggle.activityServiceTogglle,
                            expression: "toggle.activityServiceTogglle"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.activity_fee_detail.list,
                              "span-method": _vm.rowSpan
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "special_start_time",
                                label: "专场开始时间",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: "拿货单价",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "开单数量",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "activity_time",
                                label: "活动时间",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "activity_id",
                                label: "活动ID",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "activity_type",
                                label: "活动类型",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "activity_name",
                                label: "活动名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "discount_shop_price",
                                label: "小计",
                                align: "center"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "right",
                              height: "40px",
                              background: "#f3f3f3",
                              "line-height": "40px",
                              padding: "0 40px",
                              "font-size": "14px",
                              color: "#ff4040"
                            }
                          },
                          [
                            _vm._v(
                              "\n            活动服务费： ¥" +
                                _vm._s(_vm.info.activity_price) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-title",
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        "align-items": "center",
                        "justify-content": "space-between"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleFilter("activityCostTogglle")
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("el-button", {
                            staticStyle: { "margin-left": "auto" },
                            attrs: {
                              type: "text",
                              icon: _vm.toggle.activityCostTogglle
                                ? "el-icon-arrow-down"
                                : "el-icon-arrow-up"
                            }
                          }),
                          _vm._v("活动费抵扣商品\n        ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "success" },
                          on: { click: _vm.exportActivityGoods }
                        },
                        [_vm._v("\n          导出\n        ")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-collapse-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.toggle.activityCostTogglle,
                            expression: "toggle.activityCostTogglle"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-table",
                          {
                            attrs: { data: _vm.activityGoodsInfo, border: "" }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: "活动时间",
                                prop: "activity_time",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "商品名称",
                                prop: "goods_name",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "货号",
                                prop: "goods_no",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "颜色/尺码",
                                prop: "co_si",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "SKU编号",
                                prop: "sku",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "单件优惠额",
                                prop: "activity_fee",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "抵扣数量",
                                prop: "num",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "订单ID",
                                prop: "order_id",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "活动ID",
                                prop: "activity_id",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "活动类型",
                                prop: "activity_type_text",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "活动名称",
                                prop: "activity_name",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "活动费抵扣小计",
                                prop: "activity_fee_amount",
                                align: "center"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "right",
                              height: "40px",
                              background: "#f3f3f3",
                              "line-height": "40px",
                              padding: "0 40px",
                              "font-size": "14px",
                              color: "#ff4040"
                            }
                          },
                          [
                            _c("div", [
                              _vm._v(
                                "合计活动费抵扣金额：¥" +
                                  _vm._s(_vm.activity_fee_amount)
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-title",
                      on: {
                        click: function($event) {
                          return _vm.toggleFilter("concedeBenefitsToggle")
                        }
                      }
                    },
                    [
                      _c("el-button", {
                        staticStyle: { "margin-left": "auto" },
                        attrs: {
                          type: "text",
                          icon: _vm.toggle.concedeBenefitsToggle
                            ? "el-icon-arrow-down"
                            : "el-icon-arrow-up"
                        }
                      }),
                      _vm._v("\n        让利佣金账单抵扣明细\n      ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-collapse-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.toggle.concedeBenefitsToggle,
                            expression: "toggle.concedeBenefitsToggle"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.rebateData.list,
                              border: "",
                              height: "200"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "reporting_period",
                                label: "让利账期",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "bill_no",
                                label: "让利账单编号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "confirm_time",
                                label: "让利账单确认时间",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "amount_price",
                                label: "总结算金额",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "deduction_price",
                                label: "本单让利佣金抵扣金额",
                                align: "center"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "right",
                              height: "40px",
                              background: "#f3f3f3",
                              "line-height": "40px",
                              padding: "0 40px",
                              "font-size": "14px",
                              color: "#ff4040"
                            }
                          },
                          [
                            _vm._v(
                              "\n            合计让利佣金抵扣金额： ¥" +
                                _vm._s(_vm.rebateData.total) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-title",
                      on: {
                        click: function($event) {
                          return _vm.toggleFilter("goodsToggle")
                        }
                      }
                    },
                    [
                      _c("el-button", {
                        staticStyle: { "margin-left": "auto" },
                        attrs: {
                          type: "text",
                          icon: _vm.toggle.goodsToggle
                            ? "el-icon-arrow-down"
                            : "el-icon-arrow-up"
                        }
                      }),
                      _vm._v("\n        商品抵扣列表\n      ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-collapse-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.toggle.goodsToggle,
                            expression: "toggle.goodsToggle"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-table",
                          {
                            key: "table2",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.info.ded.goodsList,
                              border: "",
                              height: "400"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "img",
                                label: "商品图片",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "viewer",
                                                rawName: "v-viewer"
                                              }
                                            ],
                                            staticStyle: {
                                              width: "40px",
                                              height: "40px",
                                              overflow: "hidden",
                                              cursor: "pointer"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%"
                                              },
                                              attrs: { src: scope.row.img }
                                            })
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2311115079
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_name",
                                label: "商品名称",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goods_no",
                                label: "货号",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "co_val",
                                label: "颜色",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "si_val",
                                label: "尺码",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "brand_name",
                                label: "品牌",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pg_name",
                                label: "买手组",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "数量",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "price",
                                label: "代采价",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "status_label",
                                label: "抵扣状态",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "remainderPrice",
                                label: "剩余金额",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sum_price",
                                label: "抵扣金额",
                                align: "center"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "right",
                              height: "40px",
                              background: "#f3f3f3",
                              "line-height": "40px",
                              padding: "0 40px",
                              "font-size": "14px",
                              color: "#ff4040"
                            }
                          },
                          [
                            _vm._v(
                              "\n            合计商品抵扣金额： ¥" +
                                _vm._s(_vm.info.ded.sumPrice) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-row",
            [
              _c("div", { staticClass: "card-title" }, [_vm._v("审核信息")]),
              _vm._v(" "),
              _vm.pay_fail_msg.length > 0
                ? _c("div", { staticClass: "card-warning" }, [
                    _vm._v("\n        " + _vm._s(_vm.pay_fail_msg) + "\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { border: "1px solid #ddd", padding: "15px" } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { height: "200px" },
                      attrs: {
                        span:
                          _vm.info &&
                          (_vm.info.status == 0 ||
                            _vm.info.status == 9 ||
                            _vm.info.status == 5)
                            ? 20
                            : 24
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 9,
                          placeholder: "暂无备注信息",
                          disabled:
                            _vm.info &&
                            _vm.info.status >= 2 &&
                            _vm.info.status != 5 &&
                            _vm.info.status != 9
                        },
                        model: {
                          value: _vm.textarea,
                          callback: function($$v) {
                            _vm.textarea = $$v
                          },
                          expression: "textarea"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.info && _vm.info.status == 0
                    ? _c(
                        "el-col",
                        {
                          staticStyle: { height: "200px" },
                          attrs: { span: 4 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "justify-content": "space-around",
                                "align-items": "center",
                                height: "100%"
                              }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-operation",
                                      attrs: { type: "success" },
                                      on: { click: _vm.pass }
                                    },
                                    [
                                      _vm._v(
                                        "\n                财务审核\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-operation",
                                      attrs: { type: "danger" },
                                      on: { click: _vm.reject }
                                    },
                                    [
                                      _vm._v(
                                        "\n                驳回\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.info && _vm.info.status == 9
                    ? _c(
                        "el-col",
                        {
                          staticStyle: { height: "200px" },
                          attrs: { span: 4 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "justify-content": "space-around",
                                "align-items": "center",
                                height: "100%"
                              }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-operation",
                                      attrs: { type: "success" },
                                      on: {
                                        click: function($event) {
                                          return _vm.pass(1)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                代采审核\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-operation",
                                      attrs: { type: "danger" },
                                      on: { click: _vm.reject }
                                    },
                                    [
                                      _vm._v(
                                        "\n                驳回\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.info && _vm.info.status == 5
                    ? _c(
                        "el-col",
                        {
                          staticStyle: { height: "200px" },
                          attrs: { span: 4 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "justify-content": "space-around",
                                "align-items": "center",
                                height: "100%"
                              }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-operation",
                                      attrs: { type: "success" },
                                      on: { click: _vm.repay }
                                    },
                                    [
                                      _vm._v(
                                        "\n                重新激活\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-operation",
                                      attrs: { type: "danger" },
                                      on: { click: _vm.rejectPayFailOrder }
                                    },
                                    [_vm._v("驳回")]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("div", { staticClass: "card-title" }, [_vm._v("操作信息")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  key: "table3",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.logs, border: "", height: "400" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "action_admin",
                      label: "操作人",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action_type",
                      label: "操作方式",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action_result",
                      label: "结果",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "create_time",
                      label: "操作时间",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action_desc",
                      label: "备注",
                      align: "center"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.UpdatePayeeVisible
        ? _c(
            "div",
            [
              _c("update-payee", {
                attrs: { id: _vm.form.id, payee: _vm.payee, url: _vm.url2 },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "以下商品款号有改动,请审核",
            visible: _vm.khVisible,
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.khVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.change_kh } },
            [
              _c("el-table-column", {
                attrs: {
                  property: "goods_name",
                  label: "商品名称",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "old_kh", label: "原款号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "goods_kh",
                  label: "申请修改款号",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "1" },
                            model: {
                              value: scope.row.status,
                              callback: function($$v) {
                                _vm.$set(scope.row, "status", $$v)
                              },
                              expression: "scope.row.status"
                            }
                          },
                          [_vm._v("同意")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "2" },
                            model: {
                              value: scope.row.status,
                              callback: function($$v) {
                                _vm.$set(scope.row, "status", $$v)
                              },
                              expression: "scope.row.status"
                            }
                          },
                          [_vm._v("不同意")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.checkKh } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1af85f8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af85f8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseOrderDetail.vue
// module id = null
// module chunks = 